import React from "react";
import { Users, Lock } from "lucide-react";

// Team (shared) vs Private (owner only) segmented control.
export default function VisibilityToggle({ value = "team", onChange, testid = "visibility-toggle" }) {
  const opts = [
    { v: "team", label: "Shared With Team", icon: Users },
    { v: "private", label: "Private To Me", icon: Lock },
  ];
  return (
    <div className="inline-flex rounded-lg border border-border bg-slate-50 p-0.5" data-testid={testid} role="group" aria-label="Visibility">
      {opts.map(({ v, label, icon: Icon }) => {
        const active = value === v;
        return (
          <button
            key={v}
            type="button"
            onClick={() => onChange(v)}
            aria-pressed={active}
            data-testid={`${testid}-${v}`}
            className={`inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
              active ? "bg-white text-[#1B4383] shadow-sm" : "text-slate-500 hover:text-slate-700"
            }`}
          >
            <Icon className="h-3.5 w-3.5" />{label}
          </button>
        );
      })}
    </div>
  );
}
